<script setup lang="ts">
import type { DropdownMenuItem } from '@nuxt/ui'

const { execute: resetGame, hasHandler: hasResetHandler } = useGameReset()
const route = useRoute()
const router = useRouter()
const { t } = useI18n()

const { hasPresenterTarget, isFullscreen, toggle: toggleFullscreen } = useGameFullscreen()

const { open: openAbout } = useAboutModal()

// Defer the presenter-view check to post-mount so SSR HTML and the initial
// hydration tree always agree (the prerendered page has no query params).
const mounted = ref(false)
onMounted(() => {
  mounted.value = true
})
const hiddenInPresenterView = computed(() => mounted.value && route.query.view === 'presenter')

const items = computed<DropdownMenuItem[][]>(() => [
  [
    {
      icon: isFullscreen.value ? 'mdi:fullscreen-exit' : 'mdi:fullscreen',
      label: hasPresenterTarget.value
        ? (isFullscreen.value ? t('gameFab.fullscreen.exitPresenter') : t('gameFab.fullscreen.enterPresenter'))
        : (isFullscreen.value ? t('gameFab.fullscreen.exit') : t('gameFab.fullscreen.enter')),
      onSelect() {
        toggleFullscreen()
      },
    },
  ],
  [
    {
      icon: 'mdi:information-outline',
      label: t('gameFab.about'),
      onSelect() {
        openAbout()
      },
    },
  ],
  ...(hasResetHandler.value
    ? [
        [
          {
            color: 'warning' as const,
            icon: 'mdi:restart',
            label: t('gameFab.resetGame'),
            onSelect() {
              resetGame()
            },
          },
        ],
      ]
    : []),
  [
    {
      color: 'error' as const,
      icon: 'mdi:home-outline',
      label: t('gameFab.exitHome'),
      onSelect() {
        router.push('/')
      },
    },
  ],
])
</script>

<template>
  <div v-if="!hiddenInPresenterView" class="fixed bottom-4 left-4 z-50">
    <UDropdownMenu
      :items="items"
      :content="{ side: 'top', align: 'start', sideOffset: 8 }"
      :modal="false"
      :ui="{ content: 'w-44' }"
    >
      <SfgGameCornerButton
        icon="mdi:cog-outline"
        aria-label="Game options"
      />
    </UDropdownMenu>
  </div>
</template>
